import i18n, { TFunction } from 'i18next'
import * as Yup from 'yup'
import { DATE_FORMAT, DATE_SEPARATOR } from '../../../config'
import { ARTICLE, CUSTOM_VALIDATION_ERRORS } from '../../../models/enums'

const regExText = /^[^\s][\sa-zA-ZÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß.'-]*$/

const getValidationSchema = (storefrontData, t: TFunction) => {

  const storefrontMinAge = storefrontData?.vehicleData?.minAge
  const minAllowedAge = storefrontMinAge > 18 ? storefrontMinAge : 18

  return Yup.object().shape({
    minAge: Yup.string(),
    salutation: Yup.string().required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:salutation'), ARTICLE.EINE)),
    firstName: Yup.string()
      .matches(regExText, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:firstName'), ARTICLE.EINEN))
      .min(2, i18n.t('validation:minLength', { value: 2 }))
      .max(35, i18n.t('validation:maxLength', { value: 35 }))
      .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:firstName'), ARTICLE.EINEN)),
    lastName: Yup.string()
      .matches(regExText, CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:lastName'), ARTICLE.EINEN))
      .min(2, i18n.t('validation:minLength', { value: 2 }))
      .max(35, i18n.t('validation:maxLength', { value: 35 }))
      .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:lastName'), ARTICLE.EINEN)),
    dateOfBirth: Yup.string()
      .formatOfDate(
        DATE_FORMAT,
        DATE_SEPARATOR,
        CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:dateOfBirth'), ARTICLE.EIN)
      )
      .notInFuture(DATE_SEPARATOR, i18n.t('validation:dateInFuture'))
      .notMoreThanHundredYearsAgo(
        DATE_SEPARATOR,
        i18n.t('validation:dateMoreThanHundredYearsAgo')
      )
      .fullAge(
        minAllowedAge,
        DATE_SEPARATOR,
        i18n.t('validation:minAge', {
          minAge: minAllowedAge,
        })
      )
      .required(CUSTOM_VALIDATION_ERRORS.valueInvalid(t('personal-details:dateOfBirth'), ARTICLE.EIN)),
    licenseCheck: Yup.boolean()
      .required(i18n.t('validation:licenseCheckError'))
      .oneOf([true], i18n.t('validation:licenseCheckError')),
  })
}

export default getValidationSchema
